/**
 * Centralized image path constants
 *
 * This file contains all image paths used throughout the application.
 * Update this file to change image references across the entire codebase.
 */

import { basePath } from "@/lib/config";

/**
 * Primary Ori logos (full wordmark)
 */
export const OriLogo = {
  light: `${basePath}/images/ori-by-rapids-health-logo.png`,
  dark: `${basePath}/images/ori-by-rapids-health-dark.png`,
} as const;

/**
 * Ori symbol/icon logos (no wordmark)
 */
export const OriSymbol = {
  light: `${basePath}/images/ori-symbol.png`,
  dark: `${basePath}/images/ori-symbol-light.png`,
} as const;

/**
 * Ori background images
 */
export const OriBackgrounds = {
  bg1: `${basePath}/images/ori-background-1.png`,
  bg2: `${basePath}/images/ori-background-2.png`,
  bg3: `${basePath}/images/ori-background-3.png`,
} as const;

/**
 * Favicon and app icons
 */
export const AppIcons = {
  favicon: `${basePath}/images/favicon.ico`,
  favicon16: `${basePath}/images/favicon-16x16.png`,
  favicon32: `${basePath}/images/favicon-32x32.png`,
  faviconDark: `${basePath}/images/favicon-dark.png`,
  appleTouchIcon: `${basePath}/images/apple-touch-icon.png`,
  androidChrome192: `${basePath}/images/android-chrome-192x192.png`,
  androidChrome512: `${basePath}/images/android-chrome-512x512.png`,
} as const;
